import { useQuery } from "convex/react";
import { api } from "../../../../convex/_generated/api";

/**
 * Reactive Story subscription. Convex pushes pending → ready transitions to
 * the open session — zero polling/SSE in this hook (FR-007, P3).
 */
export function useStory(entityId: string | null) {
  // useQuery passes "skip" sentinel via undefined args — useful when entityId
  // is not yet known.
  return useQuery(api.story.queries.byEntity, entityId ? { entityId } : "skip");
}
